import { Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';

function DisclaimerPanel({ onClose }) {
  return (
    <>
      {/* Backdrop */}
      <Box
        onClick={onClose}
        sx={{
          position: 'fixed',
          inset: 0,
          backgroundColor: 'rgba(0,0,0,0.5)',
          zIndex: 10000,
        }}
      />

      {/* Panel */}
      <Box
        sx={{
          position: 'fixed',
          top: 0,
          right: 0,
          bottom: 0,
          zIndex: 10001,
          width: { xs: '100vw', sm: 'min(520px, 100vw)' },
          backgroundColor: 'var(--color-bg)',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '-8px 0 40px rgba(0,0,0,0.6)',
          border: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        {/* Header */}
        <Box sx={{ p: { xs: 2.5, sm: 4 }, pb: { xs: 1.5, sm: 2 }, flexShrink: 0 }}>
          <IconButton
            onClick={onClose}
            sx={{
              color: '#fff',
              p: 0,
              mb: 2,
              '&:hover': { backgroundColor: 'transparent', opacity: 0.8 },
            }}
          >
            <CloseIcon sx={{ fontSize: { xs: '1.6rem', sm: '2rem' } }} />
          </IconButton>

          <Typography
            variant="h4"
            sx={{
              fontFamily: '"Plus Jakarta Sans", sans-serif',
              fontWeight: 600,
              fontSize: { xs: '1.15rem', sm: '1.5rem' },
              color: '#fff',
            }}
          >
            Complete Disclaimer
          </Typography>
        </Box>

        {/* Divider */}
        <Box sx={{ height: '1px', backgroundColor: 'rgba(255,255,255,0.1)', flexShrink: 0 }} />

        {/* Scrollable content */}
        <Box
          sx={{
            flex: 1,
            overflowY: 'auto',
            p: { xs: 2.5, sm: 4 },
            pt: { xs: 2, sm: 3 },
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: 2, sm: 3 },
          }}
        >
          <Typography
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: '0.75rem', sm: '0.8rem' },
              lineHeight: 1.75,
              color: 'rgba(255,255,255,0.75)',
            }}
          >
            Payible Pty Ltd (ACN 643368496) is a Digital Currency Provider that is licensed and regulated by AUSTRAC under DCE registration number DCE100706348.
          </Typography>

          <Typography
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: '0.75rem', sm: '0.8rem' },
              lineHeight: 1.75,
              color: 'rgba(255,255,255,0.75)',
            }}
          >
            The information and services provided on this website are intended for informational purposes only and do not constitute financial, investment, legal, or tax advice. Cryptocurrency and digital asset trading involves substantial risk of loss and may not be suitable for all investors. Payible reserves the right to restrict access to its services from any jurisdiction at any time, including where regulatory requirements make it impractical or unlawful to provide services.
          </Typography>

          <Typography
            sx={{
              fontFamily: '"Open Sans", sans-serif',
              fontSize: { xs: '0.75rem', sm: '0.8rem' },
              lineHeight: 1.75,
              color: 'rgba(255,255,255,0.75)',
            }}
          >
            It is the sole responsibility of users to ensure that their use of Payible's services complies with all applicable laws and regulations in their jurisdiction of residence. By accessing this website, you represent and warrant that your use of our services is lawful in your jurisdiction. This declaration is provided for general informational and compliance purposes and does not constitute legal advice. Payible recommends that all users seek independent legal and financial advice specific to their jurisdiction before engaging in cryptocurrency transactions.
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default DisclaimerPanel;
